import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import styles from 'assets/jss/material-dashboard-pro-react/components/customToggleStyle';

interface IToggleProps {
	switchProps?: object;
	formControlProps: object;
	checked: boolean;
	label: string;
	value: string;
	disabled?: boolean;
	onChange: (event: React.FormEvent<HTMLInputElement>) => void;
}
// @ts-ignore
const useStyles = makeStyles(styles);

const CustomToggle = ({ label, checked, value, onChange, switchProps, disabled, formControlProps }: IToggleProps) => {
	const classes = useStyles();

	const formControlLabelClasses = classNames({
		[classes.label]: true,
		[classes.labelChecked]: checked,
	});

	return (
		<FormControlLabel
			disabled={disabled}
			control={
				<Switch
					checked={checked}
					color="primary"
					value={value}
					disabled={disabled}
					classes={{
						switchBase: classes.switchBase,
						checked: classes.switchChecked,
						thumb: classes.switchIcon,
						track: classes.switchBar,
						root: classes.switchRoot,
						disabled: classes.switchBaseDisabled,
					}}
					onChange={onChange}
					{...switchProps}
				/>
			}
			classes={{
				label: formControlLabelClasses,
				disabled: classes.labelDisabled,
			}}
			label={label}
			{...formControlProps}
		/>
	);
};

export default CustomToggle;
